export default "__VITE_ASSET__HrkMzBQ8__"